<template>

    <div class="container search-results-page">
        <form v-on:submit.prevent="handleForm" class="search container-fluid no-overlap" :data-context="resultsCards.dataContext">
            <label for="siteSearchResult" class="sr-only">Site Search</label>
            <input id="siteSearchResult" type="text" class="siteSearch resultSearch" :placeholder="resultsCards.searchbarPlaceholder" v-model="url.query">
            <button type="submit" class="searchSubmit" style="background-image: url(/dist/img/svg/icon-search-orange.svg);">
                <span class="sr-only">Submit Search</span>
            </button>
        </form>
        <div data-endpoint-id="SearchResultsData">
            <div class="columns row search-results">
                <div class="col-lg-3 offset-lg-9">
                    <div class="fulton-dropdown results-sort">
                        <button type="button" class="dropdown-toggle" aria-expanded="false" aria-controls="dropdownResultsSort" id="btnResultsSort" @click="fultonDropdownToggle">
							<span class="dropdown-title">
                                sort by
							</span>
							<svg aria-hidden="true" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 433.4 247" xml:space="preserve">
								<path d="M195.8,234.8L14.9,53.9c-11.6-11.6-11.6-30.2,0-41.7c11.5-11.5,30.2-11.5,41.7,0l160.1,160l160-160 c11.6-11.6,30.2-11.6,41.7,0c11.6,11.5,11.6,30.1,0,41.7L237.5,234.8c-5.7,5.7-13.3,8.6-20.8,8.6 C209.1,243.5,201.6,240.5,195.8,234.8z"></path>
							</svg>
                        </button>
                        <div class="dropdown-items" role="region" aria-labelledby="btnResultsSort" id="dropdownResultsSort">
                            <ul>
                                <li v-for="(item, index) in resultsCards.sort" :key="item.id">
                                    <button type="button" class="sort" :id="item.id" :class="{'selected': checkSort(item.id)}" @click="updateSort(item.id)" @keyup.space="updateSort(item.id)">
                                        {{item.displayName}}
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="sidebar col-lg-3">

                    <div class="filter-group">
                        
                        <div class="filter-group__section" :class="{'filter-group__section--active' : item.open}" :key="item.filterName" v-for="item in resultsCards.filters">
                            <button type="button" class="filter-group__toggle" :aria-expanded="item.open" :aria-controls="formatToId('accordion', item.filterName)" :id="formatToId('btn', item.filterName)" @click="toggleAccordion($event)">
                                <h3 class="filter-group__heading">
                                    {{ item.filterName }}
                                </h3>
                                <div class="filter-group__icon">
                                    <i aria-hidden="true"></i>
                                    <i aria-hidden="true"></i>
                                </div>
                            </button>
                            
                            <div class="filter-group__content" role="region" :aria-labelledby="formatToId('btn', item.filterName)" :id="formatToId('accordion', item.filterName)">
                                <ul class="filter-group__list">
                                    <li class="filter-group__item" :key="subitem.id" v-for="subitem in item.subfilters">
                                        <label class="filter-group__label" :class="{'filter-group__label--checked' : checkFilters(subitem.id)}" :for="subitem.id">
                                            <input class="filter-group__checkbox" :id="subitem.id" :ref="subitem.displayName" :checked="checkFilters(subitem.id)" type="checkbox" @click="toggleFilters(item.filterName, subitem.id)">
                                            <span class="filter-group__checkmark"></span>
                                            <span class="filter-group__text">{{ subitem.displayName }}</span>
                                        </label>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        
                        <div class="filter-group__buttons">
                            <button type="button" class="filter-group__button filter-group__button--apply" v-on:click="applyFilters">
                                apply <span class="sr-only">filters</span>
                            </button>
                            <button type="button" class="filter-group__button filter-group__button--clear" v-on:click="clearFilters">
                                clear all <span class="sr-only">filters</span>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="main col-lg-9">
                    <div class="sr-only" role="status" aria-live="polite" :id="statusRegionId" aria-atomic="true">
                        {{ filterStatusMessage }}
                    </div>
                    <ul class="sorted-results">
                        <li class="no-results">
                            {{resultsCards.noresults}}
                        </li>
                        <li class="results-card" :key="resultsCard.Id" v-for="resultsCard in resultsCards.total">
                            <div class="details">
                                <div class="tags has-ribbon" v-if="resultsCard.PrimaryTag">
                                    <div class="ribbon" v-if="resultsCard.PrimaryTagRGB" :style="'background-color: ' + resultsCard.PrimaryTagRGB + ';'"></div>
                                    <a href="#" :key="resultsCard.PrimaryTag[0]">
                                        <span>{{ resultsCard.PrimaryTagText }}</span>
                                    </a>
                                </div>

                                <div class="date">{{resultsCard.SearchDisplayDate}}</div>

                                <h3 class="result-title">{{ resultsCard.TeaserTitle }}</h3>

                                <div class="description">{{ resultsCard.TeaserSummary }}</div>
                                <a class="cta-primary" :href="resultsCard.TargetUrl" v-if="resultsCard.TargetUrl">
                                    {{resultsCard.TargetUrlText}}
                                    <svg version="1.1" class="icon-arrow-right" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 257.6 451.8" xml:space="preserve">
                                        <path d="M243.4,247.4L57.1,433.7c-11.9,11.9-31.1,11.9-42.9,0c-11.8-11.8-11.8-31.1,0-42.9L179,225.9L14.2,61.1 C2.3,49.2,2.3,30,14.2,18.2C26,6.3,45.2,6.3,57.1,18.2l186.3,186.3c5.9,5.9,8.9,13.7,8.9,21.4C252.3,233.7,249.3,241.5,243.4,247.4 z" />
                                    </svg>
                                </a>
                            </div>
                        </li>
                    </ul>
                    <div class="pagination" v-bind:class="{'hidden': url.pageCount <= 1}">
                        <button type="button" class="pagination-nav prev-page" v-on:click="prevPage" :disabled="url.pageNumber === 1"><span class="sr-only">Previous Page</span></button>
                        <span v-if="url.pageCount <= 5">
                            <button type="button" class="pagination-num" v-for="item in url.pageCount" v-on:click="getPage(item)" :key="item" :class="{ 'active': url.pageNumber == item}">
                                <span class="sr-only">Page </span>{{ item }}<span class="sr-only"> of {{ url.pageCount }}</span>
                            </button>
                        </span>
                        <span v-else-if="url.pageCount > 5">
                            <button type="button" v-if="item == 1 || item == url.pageCount || item == url.pageNumber - 1 || item == url.pageNumber - 2 || item == url.pageNumber + 1 || item == url.pageNumber + 2 || item == url.pageNumber" class="pagination-num" v-for="item in url.pageCount" v-on:click="getPage(item)" :key="item" :class="{ 'active': url.pageNumber == item, 'trunc-start': item == 1 && url.pageNumber > 4, 'trunc-end': item == url.pageCount && url.pageNumber < url.pageCount - 3}">
                                <span class="sr-only">Page </span>{{ item }}<span class="sr-only"> of {{ url.pageCount }}</span>
                            </button>
                        </span>
                        <button type="button" class="pagination-nav next-page" v-on:click="nextPage" :disabled="url.pageNumber === url.pageCount"><span class="sr-only">Next Page</span></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Search Results Page',
        el: '.search-results-page',
        data() {
            return {
                resultsCards: {
                    //set url to window.location.href on page load
                    urlwithquery: "https://www.fultoncounty.gov/?query=commissioners&filters=000-0000-100-0001%7C000-0000-100-0004&sortby=az&pageCount=2&pageNumber=1",
                    urlnoquery: "https://www.fultoncounty.gov/?query=&filters=&sortby=",
                    urlraw: "https://www.fultoncounty.gov/search",
                    url: window.location.href,
                    sort: [],
                    total: [],
                    filters: [],
                    searchbarPlaceholder: "",
                    noresults: "",
                    totalCount: 0

                },
                url: {
                    filters: [],
                    query: [],
                    sortBy: {},
                    pageNumber: {},
                    pageCount: {},
                    startingPath: ""
                },
                filterStatusMessage: "",
                statusRegionId: "search-results-filter-status",
                shouldScrollToResults: false,
                lastChangedState: null, // Tracks what was just changed: 'page', 'sort', 'filters', 'query', or null for default
                isUpdatingQuery: false, // Flag to prevent duplicate updateQuery calls
                searchInputElement: null // Cached reference to search input element
            }
        },

        mounted: function () {
            /* eslint-disable no-console */
            var self = this;
            
            // Cache search input element reference
            self.searchInputElement = self.$el ? self.$el.querySelector('#siteSearchResult') : document.getElementById('siteSearchResult');
            
            self.decodeUrl();//update the url in address bar regardless of how they got here
            self.setup();
            
            // Set up global dropdown handlers
            const handlers = utils.dropdown.setupGlobalHandlers();
            self.removeDropdownClickListener = handlers.removeClickListener;
            self.removeDropdownKeyListener = handlers.removeKeyListener;
            
            // Mark Vue-managed dropdowns to avoid conflicts with vanilla JS dropdown system
            const vueDropdowns = self.$el.querySelectorAll('.fulton-dropdown button[aria-controls]');
            vueDropdowns.forEach(button => {
                button.setAttribute('data-dropdown-initialized', 'vue');
            });
        },
        
        beforeDestroy: function() {
            // Clean up event listeners
            if (this.removeDropdownClickListener) {
                this.removeDropdownClickListener();
            }
            if (this.removeDropdownKeyListener) {
                this.removeDropdownKeyListener();
            }
        },
        methods: {
            setup: function () {
                var self = this;
                var dataContext = window.context;
                // Always use local origin - controller will proxy to staging if configured
                var endpoint = window.location.origin + "/api/feature/search/pagesetup";
                
                var request = new XMLHttpRequest();
                request.open('POST', endpoint, true);
                request.setRequestHeader('Content-Type', 'application/json');
                request.onload = function () {
                    if (request.status >= 200 && request.status < 400) {// Success!
                        try {
                            var response = JSON.parse(request.responseText);
                            
                            // Check if response has the expected structure
                            if (response && response.data) {
                                self.resultsCards.filters = response.data.filters || [];
                                self.resultsCards.sort = response.data.sort || [];
                                
                                // Expand accordion sections that contain checked filters
                                if (self.resultsCards.filters && self.resultsCards.filters.length > 0 && self.url.filters && self.url.filters.length > 0) {
                                    self.resultsCards.filters.forEach(function(filterSection) {
                                        // Check if any subfilter in this section is checked
                                        var hasCheckedFilter = false;
                                        if (filterSection.subfilters && filterSection.subfilters.length > 0) {
                                            hasCheckedFilter = filterSection.subfilters.some(function(subfilter) {
                                                return self.url.filters.indexOf(subfilter.id) > -1;
                                            });
                                        }
                                        // Set open state based on whether it has checked filters
                                        self.$set(filterSection, 'open', hasCheckedFilter);
                                    });
                                    
                                    // After Vue updates the DOM, programmatically expand the accordions
                                    self.$nextTick(function() {
                                        self.resultsCards.filters.forEach(function(filterSection) {
                                            if (filterSection.open) {
                                                var buttonId = self.formatToId('btn', filterSection.filterName);
                                                var trigger = self.$el ? self.$el.querySelector('#' + buttonId) : document.getElementById(buttonId);
                                                if (trigger) {
                                                    var panel = trigger.nextElementSibling;
                                                    if (panel && !trigger.classList.contains('active')) {
                                                        // Expand the accordion
                                                        panel.style.display = 'block';
                                                        trigger.classList.add("active");
                                                        trigger.setAttribute('aria-expanded', true);
                                                        var ht = panel.scrollHeight;
                                                        panel.style.height = ht + "px";
                                                        panel.classList.add("active");
                                                    }
                                                }
                                            }
                                        });
                                    });
                                } else {
                                    // If no filters are checked, ensure all sections are closed
                                    if (self.resultsCards.filters && self.resultsCards.filters.length > 0) {
                                        self.resultsCards.filters.forEach(function(filterSection) {
                                            self.$set(filterSection, 'open', false);
                                        });
                                    }
                                }
                                
                                // Only set default sortBy if not already set from URL
                                if (self.resultsCards.sort && self.resultsCards.sort.length > 0) {
                                    // Validate that the current sortBy exists in the sort options
                                    var sortExists = self.resultsCards.sort.some(function(sortOption) {
                                        return sortOption.id === self.url.sortBy;
                                    });
                                    // If sortBy from URL doesn't exist in options, use first option
                                    if (!sortExists) {
                                        self.url.sortBy = self.resultsCards.sort[0].id;
                                    }
                                }
                                self.resultsCards.searchbarPlaceholder = window.searchbarPlaceholder;
                                self.resultsCards.noresults = window.noResults;
                                if (response.data.StartingPath) {
                                    self.url.startingPath = response.data.StartingPath;
                                }
                                // Ensure query is a string before calling updateQuery
                                if (Array.isArray(self.url.query)) {
                                    self.url.query = self.url.query[0] || "";
                                }
                                if (typeof self.url.query !== 'string') {
                                    self.url.query = String(self.url.query || "");
                                }
                                
                                // Update the search input field to match the query from URL
                                var searchInput = self.getSearchInput();
                                if (searchInput && self.url.query) {
                                    searchInput.value = self.url.query;
                                }
                                
                                self.updateQuery();
                            } else {
                                console.error("SearchResults: Unexpected response structure. Expected response.data but got:", response);
                                console.error("Full response text:", request.responseText);
                            }
                        } catch (e) {
                            console.error("Error parsing response:", e);
                            console.error("Response text:", request.responseText);
                        }
                    } else {
                        // We reached our target server, but it returned an error
                        console.error("API error - Status:", request.status);
                        console.error("Response:", request.responseText);
                    }
                };

                request.onerror = function () {
                    // This often indicates a CORS issue when status is 200
                    console.error("Connection error - This may be a CORS issue");
                    console.error("Endpoint:", endpoint);
                    console.error("Status:", request.status);
                    console.error("Response available:", !!request.responseText);
                    if (request.responseText) {
                        console.error("Response text:", request.responseText);
                    }
                };
                request.send(JSON.stringify({ datasource: dataContext }));
            },
            nextPage: function () {
                var self = this;
                self.url.pageNumber++;
                self.lastChangedState = 'page';
                self.constructUrl();
                self.updateQuery();
            },
            prevPage: function () {
                var self = this;
                self.url.pageNumber--;
                self.lastChangedState = 'page';
                self.constructUrl();
                self.updateQuery();
            },
            getPage: function (num) {
                var self = this;
                self.url.pageNumber = num;
                self.lastChangedState = 'page';
                self.constructUrl();
                self.updateQuery();
            },
            getSearchInput: function () {
                var self = this;
                // Return cached reference or try to get it again
                if (!self.searchInputElement) {
                    self.searchInputElement = self.$el ? self.$el.querySelector('#siteSearchResult') : document.getElementById('siteSearchResult');
                }
                return self.searchInputElement;
            },
            scrollToSearchBar: function () {
                var self = this;
                // Use $nextTick to ensure DOM has updated after results load
                self.$nextTick(function() {
                    var searchInput = self.getSearchInput();
                    if (searchInput) {
                        searchInput.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    } else {
                        // Fallback to window scroll if element not found
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                });
            },
            updateSort: function (el) {
                var self = this;
                self.url.sortBy = el; //update data to hold id of new sort method
                self.lastChangedState = 'sort';
                self.constructUrl(); //build the url and update the browser
                self.closeSort();
                self.updateQuery(); //make the call
            },
            getSelectedFilterNames: function () {
                var self = this;
                var selectedNames = [];
                if (self.resultsCards.filters && self.resultsCards.filters.length > 0) {
                    self.resultsCards.filters.forEach(function (filterSection) {
                        if (filterSection.subfilters && filterSection.subfilters.length > 0) {
                            filterSection.subfilters.forEach(function (subfilter) {
                                if (self.url.filters.includes(subfilter.id)) {
                                    selectedNames.push(subfilter.displayName);
                                }
                            });
                        }
                    });
                }
                return selectedNames;
            },
            buildFilterStatusMessage: function () {
                var self = this;
                var messageParts = [];
                
                // Only announce what changed, not all states
                if (self.lastChangedState === 'page') {
                    var currentPage = self.url.pageNumber || 1;
                    var totalPages = self.url.pageCount || 1;
                    if (totalPages > 1) {
                        messageParts.push("Page " + currentPage + " of " + totalPages);
                    }
                } else if (self.lastChangedState === 'sort') {
                    var currentSortId = self.url.sortBy || "relevance";
                    var sortDisplayName = "relevance";
                    if (self.resultsCards.sort && self.resultsCards.sort.length > 0) {
                        var currentSort = self.resultsCards.sort.find(function(sortOption) {
                            return sortOption.id === currentSortId;
                        });
                        if (currentSort && currentSort.displayName) {
                            sortDisplayName = currentSort.displayName;
                        }
                    }
                    messageParts.push("Sorted by " + sortDisplayName);
                } else if (self.lastChangedState === 'filters') {
                    var selectedFilters = self.getSelectedFilterNames();
                    if (selectedFilters.length > 0) {
                        messageParts.push("Filters applied: " + selectedFilters.join(", "));
                    } else {
                        messageParts.push("No filters applied");
                    }
                } else if (self.lastChangedState === 'query') {
                    var queryValue = self.url.query;
                    if (Array.isArray(queryValue)) {
                        queryValue = queryValue[0] || "";
                    }
                    if (typeof queryValue !== 'string') {
                        queryValue = String(queryValue || "");
                    }
                    if (queryValue && queryValue.trim() !== "") {
                        messageParts.push('Search for "' + queryValue + '"');
                    }
                } else {
                    // Default/initial load: announce all key states
                    var queryValue = self.url.query;
                    if (Array.isArray(queryValue)) {
                        queryValue = queryValue[0] || "";
                    }
                    if (typeof queryValue !== 'string') {
                        queryValue = String(queryValue || "");
                    }
                    if (queryValue && queryValue.trim() !== "") {
                        messageParts.push('Search for "' + queryValue + '"');
                    }
                    
                    var totalResultCount = self.resultsCards.totalCount || (self.resultsCards.total ? self.resultsCards.total.length : 0);
                    if (totalResultCount === 1) {
                        messageParts.push("1 result found");
                    } else {
                        messageParts.push(totalResultCount + " results found");
                    }
                    
                    var currentPage = self.url.pageNumber || 1;
                    var totalPages = self.url.pageCount || 1;
                    if (totalPages > 1) {
                        messageParts.push("Page " + currentPage + " of " + totalPages);
                    }
                    
                    var currentSortId = self.url.sortBy || "relevance";
                    var sortDisplayName = "relevance";
                    if (self.resultsCards.sort && self.resultsCards.sort.length > 0) {
                        var currentSort = self.resultsCards.sort.find(function(sortOption) {
                            return sortOption.id === currentSortId;
                        });
                        if (currentSort && currentSort.displayName) {
                            sortDisplayName = currentSort.displayName;
                        }
                    }
                    messageParts.push("Sorted by " + sortDisplayName);
                    
                    var selectedFilters = self.getSelectedFilterNames();
                    if (selectedFilters.length > 0) {
                        messageParts.push("Filters applied: " + selectedFilters.join(", "));
                    } else {
                        messageParts.push("No filters applied");
                    }
                }
                
                return messageParts.length > 0 ? messageParts.join(". ") + "." : "";
            },
            applyFilters: function () {
                var self = this;
                self.url.pageNumber = 1;
                self.lastChangedState = 'filters';
                self.constructUrl();
                
                // Set flag to scroll after results load
                self.shouldScrollToResults = true;
                
                self.updateQuery();
            },
            toggleFilters: function (category, subcat) {
                var self = this;
                if (!self.url.filters.includes(subcat)) { //if the filter doesn't exist in data
                    self.url.filters.push(subcat); //add it
                }
                else {
                    self.url.filters = self.url.filters.filter(function (el) {
                        return el != subcat; //otherwise update the filter data without the unchecked filter
                    });
                }
            },
            clearFilters: function () {
                var self = this;
                self.url.filters = [];
                self.url.query = [];
                let searchBars = document.querySelectorAll('.siteSearch ');
                searchBars.forEach(function (bar) {
                    bar.value = "";
                })
                self.applyFilters();
            },
            closeSort: function () {
                var sorter = document.querySelectorAll(".results-sort");
                var active = sorter[0].querySelectorAll(".active");
                active.forEach(function (item) {
                    item.classList.remove("active");
                    if (item.classList.contains("accordion")) {
                        item.style.height = "0px";
                    }
                });
            },
            decodeUrl: function (url) {
                var self = this;
                url = self.resultsCards.url;
                if (!url) url = location.href;
                var question = url.indexOf("?");
                var hash = url.indexOf("#");
                if (hash == -1 && question == -1) {//missing query params
                    self.url.filters = [];
                    self.url.query = "";
                    self.url.sortBy = "relevance";
                    self.url.pageCount = "";
                    self.url.pageNumber = 1;
                    self.constructUrl();
                    return;
                };
                if (hash == -1) hash = url.length;
                var query = question == -1 || hash == question + 1 ? url.substring(hash) :
                    url.substring(question + 1, hash);
                var result = {};
                query.split("&").forEach(function (part) {
                    if (!part) return;
                    part = part.split("+").join(" "); // replace every + with space, regexp-free version
                    var eq = part.indexOf("=");
                    var key = eq > -1 ? part.substr(0, eq) : part;
                    var val = eq > -1 ? decodeURIComponent(part.substr(eq + 1)) : "";
                    val = val.split("|");
                    var from = key.indexOf("[");
                    if (from == -1) result[decodeURIComponent(key)] = val;
                    else {
                        var to = key.indexOf("]", from);
                        var index = decodeURIComponent(key.substring(from + 1, to));
                        key = decodeURIComponent(key.substring(0, from));
                        if (!result[key]) result[key] = [];
                        if (!index && !val) result[key].push(val);
                        else result[key][index] = val;
                    }
                });
                if (!result.filters || result.filters.length <= 0) {
                    self.url.filters = [];
                }
                else {
                    // Handle filters as array - if it's a single string, convert to array
                    if (Array.isArray(result.filters)) {
                        // If filters is array of arrays (from pipe-separated values), flatten it
                        var flatFilters = [];
                        result.filters.forEach(function(filter) {
                            if (Array.isArray(filter)) {
                                flatFilters = flatFilters.concat(filter);
                            } else {
                                flatFilters.push(filter);
                            }
                        });
                        self.url.filters = flatFilters.length > 0 ? flatFilters : result.filters;
                    } else {
                        // If it's a string, split by pipe separator
                        self.url.filters = result.filters.split('|').filter(function(f) { return f; });
                    }
                }
                if (!result.query || result.query.length <= 0) {
                    self.url.query = "";
                }
                else {
                    // Handle query as array (from URL parsing) or string
                    var queryValue = Array.isArray(result.query) ? result.query[0] : result.query;
                    // Ensure it's a string
                    self.url.query = typeof queryValue === 'string' ? queryValue : String(queryValue || "");
                }
                if (!result.sortBy || result.sortBy.length <= 0) {
                    self.url.sortBy = "relevance";
                }
                else {
                    // Store the sortBy from URL - will be validated after setup() loads sort options
                    var urlSortBy = Array.isArray(result.sortBy) ? result.sortBy[0] : result.sortBy;
                    self.url.sortBy = urlSortBy;
                }
                if (!result.pageCount || result.pageCount.length <= 0) {
                    self.url.pageCount = "";
                }
                else {
                    // Handle pageCount as array (from URL parsing) or number
                    var pageCountValue = Array.isArray(result.pageCount) ? result.pageCount[0] : result.pageCount;
                    self.url.pageCount = parseInt(pageCountValue, 10) || "";
                }
                if (!result.pageNumber || result.pageNumber <= 0) {
                    self.url.pageNumber = 1;
                }
                else {
                    // Handle pageNumber as array (from URL parsing) or number
                    var pageNumValue = Array.isArray(result.pageNumber) ? result.pageNumber[0] : result.pageNumber;
                    self.url.pageNumber = parseInt(pageNumValue, 10) || 1;
                }
                self.constructUrl();
            },
            constructUrl: function () {
                var self = this;
                var domain = window.location.pathname;
                var getFilters = function () {
                    return (self.url.filters.length > 0 ? self.url.filters.join('%7C') : "")
                };
                var getQuery = function () {
                    return (self.url.query ? self.url.query : "")
                };
                var getSortBy = function () {
                    return (self.url.sortBy ? self.url.sortBy : "relevance")
                };
                var getPageCount = function () {
                    return (self.url.pageCount ? self.url.pageCount : "")
                };
                var getPageNumber = function () {
                    return (self.url.pageNumber ? self.url.pageNumber : 1)
                };
                var filters = getFilters();
                var query = getQuery();
                var sortBy = getSortBy();
                var pageCount = getPageCount();
                var pageNumber = getPageNumber();
                var fullUrl = domain + "?query=" + query + "&filters=" + filters + "&sortBy=" + sortBy + "&pageNumber=" + pageNumber;
                self.updateBrowserUrl(fullUrl);
            },
            checkFilters: function (n) {
                var self = this;
                return self.url.filters.indexOf(n) > -1
            },
            checkSort: function (n) {
                var self = this;
                return self.url.sortBy.indexOf(n) > -1
            },
            updateBrowserUrl: function (newUrl) {
                window.history.pushState({}, "title", newUrl);
            },
            updateQuery: function () {
                var self = this;
                
                // Prevent duplicate calls
                if (self.isUpdatingQuery) {
                    return;
                }
                self.isUpdatingQuery = true;
                
                // Always use local origin - controller will proxy to staging if configured
                var endpoint = window.location.origin + "/api/feature/search";
                
                // Build request body
                // pageCount should be the page size (results per page), default to 5
                var pageSize = 5; // Default page size
                
                // Ensure query is a string, not an array
                var queryValue = self.url.query;
                if (Array.isArray(queryValue)) {
                    queryValue = queryValue[0] || "";
                }
                if (typeof queryValue !== 'string') {
                    queryValue = String(queryValue || "");
                }
                
                // Ensure filters is an array
                var filtersArray = self.url.filters;
                if (!Array.isArray(filtersArray)) {
                    filtersArray = [];
                }
                
                // Ensure pageNumber is a number, not an array
                var pageNumberValue = self.url.pageNumber;
                if (Array.isArray(pageNumberValue)) {
                    pageNumberValue = parseInt(pageNumberValue[0], 10) || 1;
                } else {
                    pageNumberValue = parseInt(pageNumberValue, 10) || 1;
                }
                
                var requestBody = {
                    query: queryValue,
                    filters: filtersArray.length > 0 ? filtersArray.join('|') : "",
                    sortBy: self.url.sortBy || "relevance",
                    pageNumber: pageNumberValue,
                    pageCount: pageSize, // Always send explicit page size
                    startingPath: self.url.startingPath || ""
                };
                
                var request = new XMLHttpRequest();
                request.open('POST', endpoint, true);
                request.setRequestHeader('Content-Type', 'application/json');
                request.onload = function () {
                    if (request.status >= 200 && request.status < 400) {
                        // Success!
                        try {
                            var response = JSON.parse(request.responseText);
                            
                            // Handle different response structures
                            if (response.Results) {
                                // Direct structure: { Results: [...], SortBy: "...", etc }
                                self.resultsCards.total = response.Results;
                                self.url.sortBy = response.SortBy;
                                self.url.pageNumber = response.PageNumber;
                                
                                // Store total result count
                                if (response.ResultCount !== undefined) {
                                    self.resultsCards.totalCount = response.ResultCount;
                                }
                                
                                // Calculate TotalPages if ResultsPerPage seems wrong (staging API bug)
                                if (response.ResultCount && response.ResultsPerPage) {
                                    var calculatedTotalPages = Math.ceil(response.ResultCount / pageSize);
                                    // Use calculated value if staging's TotalPages seems wrong
                                    if (response.ResultsPerPage > 100 || response.TotalPages === 1 && calculatedTotalPages > 1) {
                                        self.url.pageCount = calculatedTotalPages;
                                    } else {
                                        self.url.pageCount = response.TotalPages;
                                    }
                                } else {
                                    self.url.pageCount = response.TotalPages || 1;
                                }
                            } else if (response.Data && response.Data.Results) {
                                // Wrapped structure: { Data: { Results: [...], SortBy: "...", etc } }
                                self.resultsCards.total = response.Data.Results;
                                self.url.sortBy = response.Data.SortBy;
                                self.url.pageNumber = response.Data.PageNumber;
                                self.url.pageCount = response.Data.TotalPages;
                                
                                // Store total result count
                                if (response.Data.ResultCount !== undefined) {
                                    self.resultsCards.totalCount = response.Data.ResultCount;
                                } else if (response.ResultCount !== undefined) {
                                    self.resultsCards.totalCount = response.ResultCount;
                                }
                            } else {
                                console.error("SearchResults: Unexpected response structure:", response);
                            }
                            
                            self.resultsCheck();
                            
                            // Update status message whenever search state changes
                            self.filterStatusMessage = self.buildFilterStatusMessage();
                            
                            // Reset lastChangedState after building message
                            var changedState = self.lastChangedState;
                            self.lastChangedState = null;
                            
                            // Force screen reader announcement by briefly clearing and resetting message
                            var message = self.filterStatusMessage;
                            self.filterStatusMessage = "";
                            self.$nextTick(function() {
                                self.filterStatusMessage = message;
                            });
                            
                            // Scroll to top of results if applyFilters was called or page changed
                            if (self.shouldScrollToResults || changedState === 'page') {
                                if (self.shouldScrollToResults) {
                                    self.shouldScrollToResults = false;
                                }
                                
                                // Use $nextTick to ensure DOM has updated before scrolling
                                self.$nextTick(function() {
                                    var searchInput = self.getSearchInput();
                                    if (searchInput) {
                                        searchInput.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                    } else {
                                        // Fallback to window scroll if element not found
                                        window.scrollTo({ top: 0, behavior: 'smooth' });
                                    }
                                });
                            }
                            
                            // Reset flag after request completes
                            self.isUpdatingQuery = false;
                        } catch (e) {
                            console.error("Error parsing response:", e);
                            console.error("Response text:", request.responseText);
                            self.isUpdatingQuery = false;
                        }
                    } else {
                        // We reached our target server, but it returned an error
                        console.error("API error - Status:", request.status);
                        console.error("Response:", request.responseText);
                        self.isUpdatingQuery = false;
                    }
                };
                request.onerror = function () {
                    // This often indicates a CORS issue when status is 200
                    console.error("Connection error - This may be a CORS issue");
                    console.error("Endpoint:", endpoint);
                    console.error("Status:", request.status);
                    console.error("Response available:", !!request.responseText);
                    if (request.responseText) {
                        console.error("Response text:", request.responseText);
                    }
                    self.isUpdatingQuery = false;
                };

                request.send(JSON.stringify(requestBody));
            },
            handleForm: function () {
                var self = this;
                var searchBar = document.querySelectorAll(".resultSearch");
                self.url.query = searchBar[0].value;
                self.url.pageNumber = 1;
                self.lastChangedState = 'query';
                self.constructUrl();
                self.updateQuery();

            },
            toggleAccordion: function (event) {
                //disable accordion in footer on desktop
                const trigger = event.currentTarget;
                const panel = trigger.nextElementSibling;
                
                if (trigger.classList.contains('active')) {
                    // Closing
                    trigger.classList.remove("active");
                    trigger.setAttribute('aria-expanded', false);
                    panel.style.height = "0px";
                    panel.classList.remove("active");
                    // Set display to none after transition
                    setTimeout(() => {
                        if (!trigger.classList.contains('active')) {
                            panel.style.display = 'none';
                        }
                    }, 300); // Adjust timing as needed
                }
                else {
                    // Opening
                    panel.style.display = 'block';
                    trigger.classList.add("active");
                    trigger.setAttribute('aria-expanded', true);
                    let ht = panel.scrollHeight;
                    panel.style.height = `${ht}px`;
                    panel.classList.add("active");
                }
                
            },
            fultonDropdownToggle: function(event) {
				utils.dropdown.toggle(event);
			},
            formatToId(prefix, name) {
                if (!name) return '';
                return prefix + name.trim().replace(/\s+/g, '');
            },
            resultsCheck: function () {
                var self = this;
                let warning = document.querySelectorAll(".no-results");
                if (self.resultsCards.total.length === 0) {
                    warning[0].classList.add("active");
                }
                else {
                    warning[0].classList.remove("active");
                }
            },
        }
    };
</script>